module.exports = __webpack_public_path__ + "img/UTECHO.544261a7.png";